import * as React from 'react';
import {HeaderProps} from '../../types/mx/creditoReal/components';
import MotorfyIcon from '../../../common/components/MotorfyIcon';

export default class HeaderView extends React.Component<HeaderProps, {}> {
    constructor(props) {
        super(props);
    }

    defineClass = () => {
        const {landing, simulatorTurboCash, turboCash, simulatorProfileCreditoReal} = this.props;
        if (landing) {
            if (simulatorProfileCreditoReal || simulatorTurboCash) {
                return 'wrapper-header-landing-without-header';
            }
            if (!simulatorTurboCash) {
                if (turboCash) {
                    return 'wrapper-header-landing-turbo-cash';
                }
                return 'wrapper-header-landing';
            }
        }
        return '';
    }

    defineLogo = () => {
        const {landing, simulatorTurboCash, simulatorProfileCreditoReal} = this.props;
        if (landing) {
            if (simulatorProfileCreditoReal) {
                return '';
            }
            if (!simulatorTurboCash) {
                return 'white';
            }
        }
        return '';
    }

    render() {
        const {landing, simulatorTurboCash} = this.props;
        return (
            <div className={`position-relative ${this.defineClass()}`}>
                {landing && <div className="image-header position-absolute h-100 w-100"/>}
                <div className={`container pt-4 pb-2 mb-3 ${!landing ? 'border-bottom' : ''}`}>
                    <div className="row">
                        <div className={`col logo-brand ${simulatorTurboCash ? 'd-none d-lg-block' : ''}`}>
                            <MotorfyIcon color={this.defineLogo()}
                                         customClass="navbar-brand-img-lg"/>
                        </div>
                        {!landing && <div className="col d-flex align-items-center justify-content-end">
                            ¿DUDAS? LLÁMANOS <strong>(55) 4161-8830</strong>
                        </div>}
                    </div>
                </div>
            </div>
        );
    }
}